import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import emojiConf from '@src/public/constants/emoji';

// dayjs配置 Duration 插件
dayjs.extend(duration);

// 格式化节点时间
export const formatNodeTime = (timestamp, format) => {
    const now = dayjs.unix(timestamp);

    if (format) {
        return now.format(format);
    }

    const today = dayjs(dayjs().format('YYYY-MM-DD'));
    const yesterday = today.subtract(1, 'day');
    const tomorrow = today.add(1, 'day');

    const nowMs = now.valueOf();
    const todayMs = today.valueOf();
    const yesterdayMs = yesterday.valueOf();
    const tomorrowMs = tomorrow.valueOf();

    if (nowMs >= todayMs && nowMs < tomorrowMs) {
        return now.format('HH:mm');
    } else if (nowMs >= yesterdayMs && nowMs < todayMs) {
        return `昨日 ${now.format('HH:mm')}`;
    } else {
        return now.format('YYYY-MM-DD');
    }
};

// 格式化指定类型的节点时间
export const formatNodeTimeEnum = (timestamp, type) => {
    const typeList = new Map([[1, ''], [2, 'YYYY年'], [3, 'YYYY年M月'], [4, 'YYYY-MM-DD'], [5, 'YYYY-MM-DD HH:mm']]);

    return formatNodeTime(timestamp, typeList.get(type));
};

// 格式化人数
export const formatPeopleCount = count => {
    if (count > 99999999) {
        return `${(count / 100000000).toFixed(1)}亿`;
    } else if (count > 9999) {
        return Number((count / 10000).toFixed(1)) === 10000 ? '9999.9万' : `${(count / 10000).toFixed(1)}万`;
    } else {
        return count;
    }
};

// 评论的日期时间格式化
// 用户传入时间例如2021-07-10 13:00:33
// 如果传入时间距离当前时间超过24小时则展示XX天前
// 如果传入时间距离当前时间超过1小时但不超过24小时，则展示XX小时前
// 如果传入时间距离当前时间不超过1小时，则展示XX分前
// 如果传入时间距离当前时间不超过1分钟，则展示刚刚
export const formatCommentTime = date => {
    const currentTime = dayjs();
    const targetTime = dayjs(date);
    const ms = targetTime.isAfter(currentTime)
        ? dayjs.duration(targetTime.diff(currentTime))
        : dayjs.duration(currentTime.diff(targetTime));
    const days = Math.floor(ms.asDays());
    const hours = Math.floor(ms.asHours());
    const minutes = Math.floor(ms.asMinutes());

    if (hours >= 24) {
        return `${days}天前`;
    } else if (hours > 0) {
        return `${hours}小时前`;
    } else if (minutes > 0) {
        return `${minutes}分前`;
    } else {
        return '刚刚';
    }
};

// 格式化评论，替换表情
export const formatComment = comment => {
    const reg = /\[([^[\]]+)]/g;

    return comment.replace(reg, (match, p1) => {
        const emoji = emojiConf.find(item => item.code === `[${p1}]`);

        if (emoji) {
            return `<img style="width:0.5rem;vertical-align:text-bottom;" src="${`https://x0.ifengimg.com/fe/circle/emoji/${p1}.png`}" alt="${p1}" />`;
        }

        return match;
    });
};
